import script from "./AuthenticationCardLogo.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthenticationCardLogo.vue?vue&type=script&setup=true&lang=js"

export default script